import React from 'react';
import { Flex, Box } from 'grid-styled';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import AddButton from 'material-ui/svg-icons/content/add';
import RemoveButton from 'material-ui/svg-icons/content/remove';
// import onlyUpdateForKeys from 'recompose/onlyUpdateForKeys';
/* Components */
import AddToCartButton from '../../../_common/AddToCartButton/AddToCartButton';
import {
  smallButtonDisabledFullWidth,
  // addToCartButtonInactive,
} from '../../../../styles/button.style';
import './ProductListItemToggleButton.scss';

const iconButtonStyles = {
  iconStyle: {
    width: 20,
    height: 20,
  },
  style: {
    width: 40,
    height: 40,
    padding: 10,
  },
};

export const PromoListItemToggleButton = ({
  addToCartButtonText,
  isInCart,
  hidePlusMinus,
  product,
  inventoryQuantity,
  inventoryText,
  handleCartAddClick,
  handleRemoveFromCartClick,
  onProductClick,
  color,
  cartQty,
  borderColor,
  backgroundColor,
  containerWidth,
  handleCartToggle,
}) => (
  <div>
    <Flex
      align="center"
      className="Product--addToCartContainer"
      style={{ borderColor }}
    >
      <Box w={[1]}>
        {inventoryQuantity <= 1 ? (
          <FlatButton
            label={inventoryText}
            {...smallButtonDisabledFullWidth}
            disabled
          />
        ) : (
          <Flex justify="space-between" align="center">
            {hidePlusMinus ? null : (
              <Box className="addToCartMinusSignContainer">
                <Box className="addToCartMinusSign">
                  {isInCart && (
                    <IconButton
                      {...iconButtonStyles}
                      onClick={(e) => handleRemoveFromCartClick(e, cartQty)}
                      className="fs-ignore-rage-clicks"
                    >
                      <RemoveButton color={borderColor} />
                    </IconButton>
                  )}
                </Box>
              </Box>
            )}
            <Box w={[1]}>
              <AddToCartButton
                color={color}
                borderColor={borderColor}
                backgroundColor={backgroundColor}
                containerWidth={containerWidth}
                htmlLabel={
                  ['JOIN THE CLUB', 'LEARN MORE'].includes(addToCartButtonText)
                    ? addToCartButtonText
                    : product.parentProduct
                    ? 'SELECT FROM OPTIONS'
                    : addToCartButtonText
                }
                onClick={
                  product.parentProduct
                    ? onProductClick
                    : isInCart
                    ? handleCartToggle
                    : (e) => handleCartAddClick(e, cartQty)
                }
              />
            </Box>
            {hidePlusMinus ? null : (
              <Box className="addToCartPlusSignContainer">
                <Box className="addToCartPlusSign">
                  {!product.parentProduct && (
                    <IconButton
                      {...iconButtonStyles}
                      onClick={(e) => handleCartAddClick(e, cartQty)}
                      className="fs-ignore-rage-clicks"
                    >
                      <AddButton color={borderColor} />
                    </IconButton>
                  )}
                </Box>
              </Box>
            )}
          </Flex>
        )}
      </Box>
    </Flex>
  </div>
);

// const HyperOptimizedComponent = onlyUpdateForKeys([
//   'addToCartButtonText',
//   'inventoryText',
//   'isInCart',
//   'backgroundColor',
// ])(PromoListItemToggleButton);

export default PromoListItemToggleButton;
